
    <div class="overlay" *ngIf="isCheckUser">
      <p-progressSpinner styleClass="large-spinner"></p-progressSpinner>
    </div>

    <div class="permissions-loading" *ngIf="permissionsLoading">
      <p-progressSpinner [style]="{'width':'48px','height':'48px'}"></p-progressSpinner>
      <span>Verificando permissões...</span>
    </div>
  <div class="g-container" *ngIf="!permissionsLoading">

    <!-- CHECKIN MODE -->
    <div *ngIf="isCheckinMode" class="checkin-mode-container">
      
      <!-- Event Selection Step -->
      <div *ngIf="!eventConfirmed" class="event-selection-step">
        <div class="selection-header">
          <i class="pi pi-qrcode selection-header-icon"></i>
          <h2>{{ "adminPanel.selectEvent" | transloco }}</h2>
          <p class="selection-description">{{ "adminPanel.selectEventDesc" | transloco }}</p>
        </div>

        <div class="event-selector-card">
          <label for="checkinEventSelect">{{ "adminPanel.event" | transloco }}</label>
          <p-dropdown
            id="checkinEventSelect"
            [options]="events"
            optionLabel="name"
            [placeholder]="'common.placeholders.selectEvent' | transloco"
            [(ngModel)]="selectedEventForCheckin"
            (onChange)="onCheckinEventSelect($event)"
            [style]="{'width': '100%'}"
          ></p-dropdown>

          <div class="selection-actions">
            <button class="action-btn action-btn-primary"
              [disabled]="!selectedEventForCheckin"
              (click)="confirmEventSelection()">
              <i class="pi pi-check"></i>
              {{ 'adminPanel.confirmEvent' | transloco }}
            </button>
          </div>
        </div>
      </div>

      <!-- Checkin Controls (shown after event confirmation) -->
      <div *ngIf="eventConfirmed">
        <div class="checkin-header">
          <div class="event-info">
            <h2>{{ selectedEventForCheckin?.name }}</h2>
            <button class="action-btn action-btn-outline action-btn-sm" (click)="changeEvent()">
              <i class="pi pi-pencil"></i>
              {{ 'adminPanel.changeEvent' | transloco }}
            </button>
          </div>
          <div class="checkin-counter">
            <i class="pi pi-users"></i>
            <span class="counter-label">{{ "adminPanel.checkInsCount" | transloco }}</span>
            <span class="counter-value">{{ checkinCount }}</span>
          </div>
        </div>

        <div class="checkin-controls">
          <div class="scanner-controls">
            <button class="action-btn action-btn-primary action-btn-lg" (click)="startCheckinScanner()">
              <i class="pi pi-camera"></i>
              {{ 'adminPanel.scanQRCode' | transloco }}
            </button>
          </div>
        </div>

        <div class="last-scan-info" *ngIf="lastScannedUser">
          <i class="pi pi-info-circle"></i>
          <span>{{ "adminPanel.lastScanned" | transloco: {userId: lastScannedUser} }}</span>
        </div>
      </div>

      <!-- Scanner fullscreen -->
      <div *ngIf="scannerActive" class="scanner-overlay">
        <zxing-scanner
          [autostart]="true"
          (scanSuccess)="handleCheckinQrCode($event)"
          class="fullscreen-scanner">
        </zxing-scanner>
        
        <button class="close-scanner" (click)="scannerActive = false">
          <i class="pi pi-times"></i> {{ "adminPanel.closeScanner" | transloco }}
        </button>
      </div>
    </div>

    <!-- NORMAL ADMIN MODE -->
    <div *ngIf="!isCheckinMode">

      <!-- Admin Hero -->
      <div class="admin-hero">
        <div class="hero-left">
          <h1 class="admin-title">
            <i class="pi pi-shield"></i>
            {{ "adminPanel.title" | transloco }}
          </h1>
        </div>
        <div class="hero-stats">
          <div class="stat-card">
            <i class="pi pi-wifi stat-icon stat-icon-online"></i>
            <div class="stat-info">
              <span class="stat-value">{{ onlineUsers.length }}</span>
              <span class="stat-label">{{ 'admin.onlineUsers.title' | transloco }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Cards de navegação -->
      <div class="admin-nav-grid">
        <a class="ai-nav-card admin-nav-card-btn ftds-chamfer-bordered"
           [class.ai-nav-card-disabled]="!isSuperAdmin"
           [routerLink]="isSuperAdmin ? '/management/users' : null">
          <div class="ai-nav-card-icon"><i class="pi pi-users"></i></div>
          <div class="ai-nav-card-body">
            <h3 class="ai-nav-card-title">Usuários</h3>
            <p class="ai-nav-card-desc">Gerencie contas, planos, senhas e permissões.</p>
          </div>
          <i class="pi pi-lock ai-nav-card-arrow" *ngIf="!isSuperAdmin"></i>
          <i class="pi pi-arrow-right ai-nav-card-arrow" *ngIf="isSuperAdmin"></i>
        </a>
        <a class="ai-nav-card admin-nav-card-btn ftds-chamfer-bordered" *ngIf="requireApproval"
           [class.ai-nav-card-disabled]="!isSuperAdmin"
           [routerLink]="isSuperAdmin ? '/management/access' : null">
          <div class="ai-nav-card-icon"><i class="pi pi-user-plus"></i></div>
          <div class="ai-nav-card-body">
            <h3 class="ai-nav-card-title">Controle de Acesso</h3>
            <p class="ai-nav-card-desc">Aprove novos cadastros e gerencie a whitelist de emails.</p>
          </div>
          <i class="pi pi-lock ai-nav-card-arrow" *ngIf="!isSuperAdmin"></i>
          <i class="pi pi-arrow-right ai-nav-card-arrow" *ngIf="isSuperAdmin"></i>
        </a>
        <a class="ai-nav-card admin-nav-card-btn ftds-chamfer-bordered"
           [class.ai-nav-card-disabled]="!isSuperAdmin"
           [routerLink]="isSuperAdmin ? '/management/projects' : null">
          <div class="ai-nav-card-icon"><i class="pi pi-folder"></i></div>
          <div class="ai-nav-card-body">
            <h3 class="ai-nav-card-title">Projetos</h3>
            <p class="ai-nav-card-desc">Visualize e gerencie o status dos projetos.</p>
          </div>
          <i class="pi pi-lock ai-nav-card-arrow" *ngIf="!isSuperAdmin"></i>
          <i class="pi pi-arrow-right ai-nav-card-arrow" *ngIf="isSuperAdmin"></i>
        </a>
        <a class="ai-nav-card admin-nav-card-btn ftds-chamfer-bordered" routerLink="/management/kb-support">
          <div class="ai-nav-card-icon"><i class="pi pi-database"></i></div>
          <div class="ai-nav-card-body">
            <h3 class="ai-nav-card-title">Base de Conhecimento</h3>
            <p class="ai-nav-card-desc">Curadoria dos itens extraídos das conversas de suporte.</p>
          </div>
          <i class="pi pi-arrow-right ai-nav-card-arrow"></i>
        </a>
        <a class="ai-nav-card admin-nav-card-btn ftds-chamfer-bordered" routerLink="/management/skills">
          <div class="ai-nav-card-icon"><i class="pi pi-bolt"></i></div>
          <div class="ai-nav-card-body">
            <h3 class="ai-nav-card-title">Skills IA</h3>
            <p class="ai-nav-card-desc">Gerencie os especialistas globais disponíveis no chatbot.</p>
          </div>
          <i class="pi pi-arrow-right ai-nav-card-arrow"></i>
        </a>
        <a class="ai-nav-card admin-nav-card-btn ftds-chamfer-bordered" routerLink="/management/moderation">
          <div class="ai-nav-card-icon"><i class="pi pi-flag"></i></div>
          <div class="ai-nav-card-body">
            <h3 class="ai-nav-card-title">{{ 'adminModeration.title' | transloco }}</h3>
            <p class="ai-nav-card-desc">{{ 'adminModeration.subtitle' | transloco }}</p>
          </div>
          <i class="pi pi-arrow-right ai-nav-card-arrow"></i>
        </a>
        <a class="ai-nav-card admin-nav-card-btn ftds-chamfer-bordered" routerLink="/management/plans">
          <div class="ai-nav-card-icon"><i class="pi pi-credit-card"></i></div>
          <div class="ai-nav-card-body">
            <h3 class="ai-nav-card-title">Planos</h3>
            <p class="ai-nav-card-desc">Crie, edite e publique os planos no Stripe.</p>
          </div>
          <i class="pi pi-arrow-right ai-nav-card-arrow"></i>
        </a>
        <a class="ai-nav-card admin-nav-card-btn ftds-chamfer-bordered" routerLink="/management/token-packages">
          <div class="ai-nav-card-icon"><i class="pi pi-bolt"></i></div>
          <div class="ai-nav-card-body">
            <h3 class="ai-nav-card-title">Pacotes de Tokens</h3>
            <p class="ai-nav-card-desc">Crie, edite e publique os pacotes de tokens avulsos no Stripe.</p>
          </div>
          <i class="pi pi-arrow-right ai-nav-card-arrow"></i>
        </a>
      </div>


    <!-- ═══ ONLINE USERS SECTION ═══ -->
    <div class="admin-section" *ngIf="!isCheckinMode">
      <div class="section-header-modern">
        <div class="section-title-row">
          <i class="pi pi-wifi section-icon"></i>
          <h2 class="section-title">{{ 'admin.onlineUsers.title' | transloco }}</h2>
        </div>
        <div class="section-actions">
          <span class="online-count-badge">
            {{ onlineUsers.length }} {{ 'admin.onlineUsers.count' | transloco }}
          </span>
          <button class="action-btn action-btn-primary action-btn-sm" (click)="refreshOnlineUsers()" [disabled]="isLoadingOnline">
            <i class="pi pi-refresh" [class.pi-spin]="isLoadingOnline"></i>
            {{ 'admin.onlineUsers.refresh' | transloco }}
          </button>
        </div>
      </div>

      <div *ngIf="isLoadingOnline && onlineUsers.length === 0" class="loading-state">
        <p-progressSpinner styleClass="small-spinner"></p-progressSpinner>
      </div>

      <p-table
        *ngIf="!isLoadingOnline || onlineUsers.length > 0"
        [value]="onlineUsers"
        [tableStyle]="{ 'min-width': '50rem' }"
        [paginator]="true"
        paginatorDropdownAppendTo="body"
        [rows]="10"
        [rowsPerPageOptions]="[5, 10, 30]"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="{{ 'admin.tableShare.currentPage' | transloco }}"
      >
        <ng-template pTemplate="header">
          <tr>
            <th>{{ 'admin.tableShare.name' | transloco }}</th>
            <th>Nickname</th>
            <th>{{ 'admin.tableShare.email' | transloco }}</th>
            <th>{{ 'admin.onlineUsers.lastSeen' | transloco }}</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-user>
          <tr>
            <td>{{ user.name }}</td>
            <td>{{ user.nickname }}</td>
            <td>{{ user.email }}</td>
            <td>{{ user.lastSeenAt | date:'dd/MM/yyyy HH:mm:ss' }}</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="4">
              <div class="empty-state">
                <i class="pi pi-users-minus"></i>
                <span>{{ 'admin.onlineUsers.empty' | transloco }}</span>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>







    </div> <!-- End normal admin mode -->
  </div>
  <p-toast key="toastMessage" />
